import { startPoster } from "../../../services/assetsGenerationAPI";

export const handleStartGeneratingPoster = async ({
  publicationId,
  token,
  posterContentLevel,
  setActiveTasks,
  setTaskStatus,
  setAlert,
  setupWebSocket,
  setOpenPosterDialog,
  posterId = null,
  setRefreshTrigger = null,
}) => {
  try {
    const uniqueId = "pending";
    setActiveTasks((prev) => {
      const nextArr = [...(prev.poster || [])];
      if (!nextArr.includes(uniqueId)) nextArr.push(uniqueId);
      return { ...prev, poster: nextArr };
    });
    localStorage.setItem("activeTasks", "true");
    setTaskStatus(prev => ({
      ...prev,
      poster: {
        ...(prev.poster || {}),
        [uniqueId]: { progress: 0, status: "queued", publicationId: Number(publicationId) }
      }
    }));

    const result = await startPoster(publicationId, token, posterContentLevel, posterId);

    if (result.error) {
      setAlert({ severity: "warning", message: result.error });
      setActiveTasks(prev => ({ ...prev, poster: (prev.poster || []).filter(id => id !== "pending") }));
      setTaskStatus(prev => { const n = { ...prev }; if (n.poster) { n.poster = { ...n.poster }; delete n.poster["pending"]; } return n; });
    } else if (result.task_id) {
      setupWebSocket(result.task_id, "poster", publicationId, result.project_id || null, (message, severity) => {
        setAlert({ severity, message });
      });
      setAlert({ severity: "success", message: "Poster Generation Started" });
      setActiveTasks(prev => ({ ...prev, poster: (prev.poster || []).filter(id => id !== "pending") }));
      setTaskStatus(prev => { const n = { ...prev }; if (n.poster) { n.poster = { ...n.poster }; delete n.poster["pending"]; } return n; });
      if (setRefreshTrigger) {
        setRefreshTrigger(prev => prev + 1);
      }
    }
    setOpenPosterDialog(false);
  } catch (error) {
    setAlert({
      severity: "warning",
      message: "Failed to start Poster generation. Please try again.",
    });
    setActiveTasks(prev => ({ ...prev, poster: (prev.poster || []).filter(id => id !== "pending") }));
    setTaskStatus(prev => { const n = { ...prev }; if (n.poster) { n.poster = { ...n.poster }; delete n.poster["pending"]; } return n; });
  }
  setOpenPosterDialog(false);
};

export const handleOpenPosterDialog = (setOpenPosterDialog) => {
  setOpenPosterDialog(true);
};

export const handleClosePosterDialog = (setOpenPosterDialog) => {
  setOpenPosterDialog(false);
};
